module.exports = __webpack_public_path__ + "img/DF_desk_blue_arrow.bcdc5dad.svg";